module.exports = __webpack_public_path__ + "img/Biztap_logo-removebg-preview (3).0906591c.png";